// extracted by mini-css-extract-plugin
export default {"form":"InputForm_form__PCJQ3","input":"InputForm_input__9gxBn","button":"InputForm_button__iaA1e"};